export default "__VITE_ASSET__ChgH01ij__"